import { render, staticRenderFns } from "./PxCriterio.vue?vue&type=template&id=421f09d3&"
import script from "./PxCriterio.vue?vue&type=script&lang=js&"
export * from "./PxCriterio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports